import React, { Component } from 'react'
import Linkify from "linkifyjs/react";
import TagsCount from "./tags-count";

const FeedComment = React.createClass({
  getInitialState() {
    return {
      truncateComment: shouldTruncateComment(this.props)
    }
  },
  componentWillReceiveProps(nextProps) {
    // Only update truncateComment if the feed comment has changed
    if (this.props.comment !== nextProps.comment) {
      this.setState({
        truncateComment: shouldTruncateComment(nextProps)
      });
    }
  },
  render() {
    const { mentions, truncateCommentAt, commentEdited, tags } = this.props;
    const { truncateComment } = this.state;
    let { comment } = this.props;

    if (mentions && mentions.length > 0) {
      comment = applyMentionsToComment(comment, mentions);
    }

    return (
      <div className="feed-comment">
        { comment &&
          <Linkify options={linkifyOptions}>
            {truncateComment &&
              <span>{ this.truncateComment(comment, truncateCommentAt) }</span>
            }
            {!truncateComment && // TODO - Ask Ben why non truncated comment is dangerously set
              <span dangerouslySetInnerHTML={{__html: comment }} />
            }
          </Linkify>
        }
        { (commentEdited && !truncateComment) &&
          <span className="comment-edited">&nbsp;(edited)&nbsp;</span>
        }
        { tags && tags.length > 0 &&
          <TagsCount tags={tags} />
        }
      </div>
    );
  },
  getComment(comment, truncateCommentAt) {
    comment = this.state.truncateComment ? this.truncateComment(comment, truncateCommentAt) : comment;
    return comment;
  },
  truncateComment(comment, truncateCommentAt) {
    return (
      <span>
        { comment.substring(0, truncateCommentAt) }...&nbsp;
        <a
          href="#"
          className="see-more-comment"
          onClick={ this.handleSeeMoreClick }
        >
          See More
        </a>
      </span>
    );
  },
  handleSeeMoreClick(e) {
    e.preventDefault();
    this.setState({ truncateComment: false })
  }
});

function shouldTruncateComment(props) {
  return Boolean(props.truncateCommentAt && props.comment.length > props.truncateCommentAt);
}

const linkifyOptions = {
  format: {
    url: function (value) {
      return value.length > 50 ? value.slice(0, 50) + '…' : value
    }
  },
  ignoreTags: [
    'script',
    'style'
  ]
};

function applyMentionsToComment(comment, mentions) {
  let name, startSlice, endSlice, mentionsList = mentions.slice(0);
  comment = comment.replace(/&amp;/g, '&');
  mentionsList = mentionsList.reverse();
  mentionsList.map((mention, i) => {
    name = comment.substring(mention.start_end[0], mention.start_end[1]);
    startSlice = comment.slice(0, mention.start_end[0]);
    endSlice = comment.slice(mention.start_end[1], comment.length);
    comment = `${startSlice}<a href="/profile/public/${mention.user_id}">${name}</a>${endSlice}`;
  });
  comment = comment.replace(/&/g, '&amp;');
  return comment;
}

export default FeedComment;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-comment.es6